import { Badge, Card, Group, Modal, ScrollArea, Text } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ChunkItem } from '@mygpt/app';

interface Props {
  item: ChunkItem;
  selected: boolean;
  onSelectedChange: (selected: boolean) => void;
  deleteFile?: (id: string) => Promise<void>;
  showScore?: boolean;
}

export default (props: Props) => {
  const { t } = useTranslation();
  const { item, showScore } = props;
  const [opened, setOpened] = useState(false);

  const chunkIndexString = (item.metadata.chunk_index + 1).toString();

  const formatChunkIndex = (chunkIndex: string) => {
    const maxChunkIndexLength = 3;
    const chunkIndexLength = chunkIndex.length;
    const diff = maxChunkIndexLength - chunkIndexLength;
    if (diff > 0) {
      return '0'.repeat(diff) + chunkIndex;
    }
    return chunkIndex;
  };

  const renderIndex = () => {
    return (
      <>
        <Badge variant="outline" radius={4} c="violet" pl={4} pr={4}>
          # {formatChunkIndex(chunkIndexString)}
        </Badge>
        {showScore && (
          <span className="text-gray-400 text-sm">
            {t('dataset.chunk_match_score')} {item.score}
          </span>
        )}
      </>
    );
  };

  const renderCharacterCount = () => {
    return (
      <>
        {item.text.length}
        <span className="text-gray-400">{t('dataset.chunk_tokens')}</span>
      </>
    );
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        size="xl"
        title={
          <Group gap="sm" className="text-sm">
            {renderIndex()}
            {renderCharacterCount()}
          </Group>
        }
      >
        <Text size="xs" mt="md" mb="md" className="text-gray-400 whitespace-break-spaces">
          {item.text}
        </Text>
      </Modal>
      <Card
        mr="sm"
        mb="sm"
        p="sm"
        radius={4}
        className="border border-transparent cursor-pointer hover:border-violet-500"
        onClick={() => setOpened(true)}
      >
        <Group gap="sm">{renderIndex()}</Group>
        <ScrollArea.Autosize mah={240} h={240} type="scroll">
          <Text
            size="xs"
            mt="md"
            mb="md"
            className="text-gray-400 whitespace-break-spaces"
            style={{ wordBreak: 'break-word' }}
          >
            {item.text}
          </Text>
        </ScrollArea.Autosize>
        <Group gap="sm" className="text-sm">
          {renderCharacterCount()}
        </Group>
      </Card>
    </>
  );
};
